// String helpers for the vendor logo SVGs we inline. Pure, so they can be unit
// tested against the real icon files.

// White fills drawn for a dark backdrop follow the text color instead.
export function whiteToCurrentColor(svg: string): string {
  return svg.replace(/fill=("|')(#fff|#ffffff|white)\1/gi, 'fill="currentColor"');
}

// Gradient/clip ids must be unique per page: a duplicate resolves to the first
// copy, and if that one is hidden every other copy loses its gradient.
export function scopeSvgIds(svg: string, suffix: string): string {
  const ids = [...svg.matchAll(/\sid="([^"]+)"/g)].map((m) => m[1]);
  let out = svg;
  for (const id of ids) {
    const scoped = `${id}-${suffix}`;
    out = out
      .split(`id="${id}"`).join(`id="${scoped}"`)
      .split(`url(#${id})`).join(`url(#${scoped})`)
      .split(`href="#${id}"`).join(`href="#${scoped}"`);
  }
  return out;
}
